import React from "react";
import { Link } from "react-router-dom";
// Image
import Error404Image from "../assets/404_error.png";

const PageNotFound = () => {
    return (
        <div className="flex flex-col items-center justify-center h-screen">
            <img src={Error404Image} alt="Illustration of a 404 error page not found" className="h-64 p-8" />
            <h1 className="text-2xl font-bold">
                This Page Missed Its Shift
            </h1>
            <p className="text-black max-w-2xl text-center p-6">
                The page you're after is either off-duty or no longer on the
                rotation. But don’t worry, there are plenty of promising
                opportunities waiting for you.
            </p>
            <Link
                to="/"
                className="text-white bg-black px-6 py-2 rounded-full font-medium text-sm hover:bg-black transition mt-4"
            >
                Back to Home Page
            </Link>
        </div>
    );
};

export default PageNotFound;
